// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__X14Hw","logoHeading":"Logo_logoHeading__vKhYg","backHome":"Logo_backHome__5u1R9"};